import React, { useState } from 'react';
import { X, Sparkles, TrendingUp, Wand2, Lock } from 'lucide-react';
import AIChatPanel from './AIChatPanel';
import DataAnalytics from './DataAnalytics';

const RightSidebar = ({
    isOpen,
    onClose,
    // Chat props
    chatMessages,
    isProcessing,
    isGenerating,
    currentInput,
    setCurrentInput,
    handleSendMessage,
    isRecording,
    isTranscribing,
    toggleRecording,
    // Analytics props
    data,
    headers,
    // Generation props
    contextFile,
    onContextFileClick,
    onRemoveContextFile,
    includeSearch,
    setIncludeSearch,
    isGenerationMode,
    userSelectedFormat,
    setUserSelectedFormat,
    // Format flag
    isConversationalFormat
}) => {
    const [activeTab, setActiveTab] = useState('chat'); // 'chat' or 'analytics'

    if (!isOpen) return null;

    return (
        <>
            {/* Sidebar Panel */}
            <div className="fixed top-0 right-0 h-screen w-96 border-l border-gray-200 bg-white flex flex-col shadow-2xl z-[100] animate-in slide-in-from-right duration-300 pointer-events-auto">
                {/* Header with Tabs */}
                <div className="border-b border-gray-200 bg-white">
                    {/* Tabs */}
                    <div className="flex items-center">
                        <button
                            onClick={() => setActiveTab('chat')}
                            className={`flex-1 px-4 py-3 text-sm font-medium transition-all border-b-2 ${activeTab === 'chat'
                                ? 'border-blue-600 text-blue-600 bg-blue-50/50'
                                : 'border-transparent text-gray-500 hover:text-gray-700 hover:bg-gray-50'
                                }`}
                        >
                            <div className="flex items-center justify-center gap-2">
                                <Sparkles size={16} />
                                <span>AI Chat</span>
                            </div>
                        </button>
                        <button
                            onClick={() => setActiveTab('analytics')}
                            className={`flex-1 px-4 py-3 text-sm font-medium transition-all border-b-2 ${activeTab === 'analytics'
                                ? 'border-blue-600 text-blue-600 bg-blue-50/50'
                                : 'border-transparent text-gray-500 hover:text-gray-700 hover:bg-gray-50'
                                }`}
                        >
                            <div className="flex items-center justify-center gap-2">
                                <TrendingUp size={16} />
                                <span>Analytics</span>
                            </div>
                        </button>
                        <div className="px-2 border-b-2 border-transparent">
                            <button
                                onClick={onClose}
                                className="text-gray-400 hover:text-gray-600 transition-colors p-1.5 hover:bg-gray-100 rounded-md"
                                title="Close Panels"
                            >
                                <X size={18} />
                            </button>
                        </div>
                    </div>
                </div>
                {/* Tab Content */}
                <div className="flex-1 overflow-hidden">
                    {activeTab === 'chat' ? (
                        isConversationalFormat ? (
                            <div className="flex flex-col items-center justify-center h-full text-center px-8 gap-5 bg-gray-50/60">
                                <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-indigo-100 to-blue-100 flex items-center justify-center shadow-inner">
                                    <Lock size={28} className="text-indigo-400" />
                                </div>
                                <div>
                                    <h3 className="text-base font-semibold text-gray-800 mb-1">Cleaning Coming Soon</h3>
                                    <p className="text-sm text-gray-500 leading-relaxed">
                                        AI-powered cleaning for conversational&nbsp;/&nbsp;JSONL data is on its way.
                                        For now, you can still generate new conversational datasets by clicking on Clear All and Generate Data.
                                    </p>
                                </div>
                                <div className="flex items-center gap-2 px-4 py-2 bg-indigo-50 border border-indigo-100 rounded-full">
                                    <Wand2 size={14} className="text-indigo-500" />
                                    <span className="text-xs font-medium text-indigo-600">Generation-only mode</span>
                                </div>
                            </div>
                        ) : (
                            <AIChatPanel
                                chatMessages={chatMessages}
                                isProcessing={isProcessing}
                                isGenerating={isGenerating}
                                currentInput={currentInput}
                                setCurrentInput={setCurrentInput}
                                handleSendMessage={handleSendMessage}
                                isRecording={isRecording}
                                isTranscribing={isTranscribing}
                                toggleRecording={toggleRecording}
                                contextFile={contextFile}
                                onContextFileClick={onContextFileClick}
                                onRemoveContextFile={onRemoveContextFile}
                                includeSearch={includeSearch}
                                setIncludeSearch={setIncludeSearch}
                                isGenerationMode={isGenerationMode}
                                userSelectedFormat={userSelectedFormat}
                                setUserSelectedFormat={setUserSelectedFormat}
                            />
                        )
                    ) : (
                        <DataAnalytics
                            data={data}
                            headers={headers}
                        />
                    )}
                </div>
            </div>
        </>
    );
};

export default RightSidebar;
